import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { JoinedPage } from '#src/pages/SavedItemsPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/saved_/orgs')({
  component: RouteComponent
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'head.joined-businesses',
            defaultMessage: 'Joined businesses'
          })}
        </title>
      </Head>

      <JoinedPage />
    </>
  );
}
